import React from 'react'
import MiniCalendarLogo from '@/assets/images/mini-calendar-logo.png'
import LoadingCalu from '@/components/LoadingCalu'
import NavBar from '@/components/NavBar'
import { useSidebar } from '@/context/SidebarContext'

import s from './styles.module.scss'

const Layout1 = ({ navbar, leftSidebar = null, isLoading, children }) => {
  const { leftSidebarIsHidden, setLeftSidebarIsHidden } = useSidebar()

  return (
    <div className={s['layout-container']}>
      {navbar && (
        <div className={s['navbar-container']}>
          <NavBar />
        </div>
      )}

      {isLoading && <LoadingCalu />}

      <div className={s['content']}>
        {leftSidebar && (
          <div className={`${s['left-sidebar']} ${leftSidebarIsHidden && s['hidden']}`}>
            <div className={s['left-sidebar-toggle']} onClick={() => setLeftSidebarIsHidden(!leftSidebarIsHidden)}>
              <img
                className={`${s.icon} ${leftSidebarIsHidden && s.hidden} calendarTriggerBtn`}
                src={MiniCalendarLogo}
                alt="Icono calendario"
              />
            </div>

            <div className={s['sidebar-container']}>{leftSidebar}</div>
          </div>
        )}

        <div className={s['body']}>
          <div className={s['body-container']}>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default Layout1
